import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getShiftJobDetails } from "../../slice/workerShiftAddJobSlice";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const WorkerShiftJobDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  const { shiftJobDetails, loading, error } = useSelector(
    (state) => state.workerShiftJob
  );

  useEffect(() => {
    dispatch(getShiftJobDetails({ id, token }));
  }, [id, token, dispatch]);

  // console.log("shiftJobDetails", shiftJobDetails);

  // if (loading) {
  //   return (
  //     <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
  //       <div className="spinner-border text-primary" role="status" />
  //     </div>
  //   );
  // }

  // /* ❌ ERROR */
  // if (error) {
  //   return <div className="text-danger text-center mt-4">{error}</div>;
  // }

  /* 📭 NO DATA */
  if (!shiftJobDetails || !shiftJobDetails.shift_request) {
    return <div className="text-center mt-4"></div>;
  }

  /* ✅ SAFE TO USE */
  const shift = shiftJobDetails.shift_request;
  const assigns = shiftJobDetails.shift_request_assigns || [];
  const approvals = shiftJobDetails.shift_request_approve || [];

  const [fromAge, toAge] = shift.classroom_age_group
    ? shift.classroom_age_group.split("-")
    : ["", ""];

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "accepted":
        return "bg-success";
      case "declined":
        return "bg-danger";
      default:
        return "bg-secondary";
    }
  };

  return (
    <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
      <div className="ps-2 ps-lg-4">
        <div className="d-flex align-items-center justify-content-between mb-4 border-bottom pb-3">
          <h4 className="font-weight-bold text-primary font-size-40 line-hight-2 montserrat mb-0">
            Shift Job Details
          </h4>
          <button
            className="btn btn-light-header"
            onClick={() => navigate(-1)}
          >
            ← Back
          </button>
        </div>

        {/* LOADING */}
        {loading && <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>}

        {/* ERROR */}
        {error && <p className="text-danger">{error}</p>}

        {!loading && !error && (
          <div className="card shadow-sm border-0 rounded-4 p-4">

            {/* 🔹 Header */}
            <div className="border-bottom pb-3 mb-4">
              <h3 className="text-primary fw-bold mb-1">{shift.title}</h3>
            </div>

            {/* 🔹 Job Info */}
            <div className="row g-3 mb-4">

              <div className="col-md-4">
                <div className="p-3 bg-light rounded-3">
                  <strong>💰 Salary</strong>
                  <div className="mt-2">{shift.salary_min} - {shift.salary_max} ({shift.ratio})</div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="p-3 bg-light rounded-3">
                  <strong>📍 Location</strong>
                  <div className="mt-2">{shift.city}, {shift.state}, {shift.country}</div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="p-3 bg-light rounded-3">
                  <strong>👔 Role</strong>
                  <div className="mt-2">
                    {shift.role_type === "5"
                      ? "Teachers & Assistants"
                      : shift.role_type === "6"
                        ? "Support Staffing Roles"
                        : shift.role_type}
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="p-3 bg-light rounded-3">
                  <strong>🕒 Start</strong>
                  <div className="mt-2">{shift.start_date} {shift.start_time?.slice(0, 5)}</div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="p-3 bg-light rounded-3">
                  <strong>🕔 End</strong>
                  <div className="mt-2">{shift.end_date} {shift.end_time?.slice(0, 5)}</div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="p-3 bg-light rounded-3">
                  <strong>🎒 Classroom Age</strong>
                  <div className="mt-2">{fromAge && toAge ? `${fromAge} - ${toAge} years` : "N/A"}</div>
                </div>
              </div>

            </div>

            {/* 🔹 Description */}
            <div className="mb-4">
              <h6 className="fw-bold mb-2">📝 Description</h6>
              <div
                className="p-3 bg-light rounded-3"
                dangerouslySetInnerHTML={{ __html: shift.description }}
              />
            </div>

            {/* 🔹 Assigned Workers */}
            <div className="mb-4">
              <h6 className="fw-bold mb-3">👥 Assigned Workers</h6>

              {assigns.length === 0 ? (
                <p className="text-muted">No assigned workers</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover align-middle">
                    <thead>
                      <tr>
                        <th>👤 Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {assigns.map((a) => (
                        <tr key={a.id}>
                          <td>{a.worker_name}</td>
                          <td>{a.worker_email}</td>
                          <td>{a.worker_phone}</td>
                          <td>
                            <span className={`badge ${getStatusClass(a.status)} px-3 py-2 font-size-14`}>{a.status}</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {/* 🔹 Approved Workers */}
            {approvals.length > 0 && (
              <div className="mb-4">
                <div className="card shadow-sm border-0">
                  <div className="card-header bg-success text-white fw-bold">
                    ✅ Acknowledged Workers
                  </div>

                  <ul className="list-group list-group-flush">
                    {approvals.map((a) => (
                      <li
                        key={a.id}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >
                        {/* Left: Worker Info */}
                        <div className="me-3" style={{ minWidth: "200px" }}>
                          <div className="fw-semibold">👤 {a.worker_name}</div>
                          <div className="text-muted small mt-2">{a.worker_email}</div>
                        </div>

                        {/* Middle: Date & Time */}
                        <div className="flex-grow-1">
                          <div className="small">
                            📅 <strong>Dates:</strong> {a.shift_request_start_date} → {a.shift_request_end_date}
                          </div>
                          <div className="small mt-2">
                            ⏰ <strong>Time:</strong> {a.shift_request_start_time} → {a.shift_request_end_time}
                          </div>
                        </div>

                        {/* Right: View Button */}
                        <div className="ms-3">
                          <Link
                            to={`/panel/assigned-shift-job-details/${a.id}`}
                            className="btn btn-outline-success btn-sm"
                          >
                            View Logs
                          </Link>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}



          </div>

        )}
      </div>
    </div>
  );
};

export default WorkerShiftJobDetails;
